import { render } from "./SVGMinus.vue?vue&type=template&id=1b3ab9f3"
import script from "./SVGMinus.vue?vue&type=script&lang=js"
export * from "./SVGMinus.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__